module.exports = __webpack_public_path__ + "static/media/Teak-wood.2cca9810.jpg";